import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
  Header,
  Heading,
  Main,
  SubHeading,
} from "../commons/Template/Template";
import authAPI from "../../api/authentication";
import routes, { dashboardRoute } from "../../routes/routes";
import { useToastsDispatch } from "../commons/Toasts/ToastsContext";
import { useAuth } from "../../auth/AuthContext";
import { useKeyLocation } from "./KeyRedirect";

// Perform e-mail address validation upon user click on e-mail button;
// if validation fails show message, else redirect to log-in page.
export default function EmailConfirmation() {
  const { t } = useTranslation(["common", "account"]);
  const key = useKeyLocation();
  const [keyStatus, setKeyStatus] = useState("");
  const navigate = useNavigate();
  document.title = t("account:emailConfirmation.title");
  const dispatchToast = useToastsDispatch();
  const { loadingLogged, logged } = useAuth();

  const handleKeyValidation = async () => {
    const response = await authAPI.verifyEMailAddress(key);
    switch (response.status) {
      case 200:
        setKeyStatus("valid");
        break;
      case 400:
        setKeyStatus("invalid");
        break;
      case 404:
        setKeyStatus("expired");
        break;
      default:
        console.log("?");
        break;
    }
  };

  useEffect(() => {
    if (!key) {
      navigate(routes.Home, { replace: true });
    } else {
      handleKeyValidation();
    }
  }, [key]);

  const handleKeyStatus = () => {
    const handleValid = () => {
      const successToast = {
        id: "EmailConfirmationValid",
        variant: "success",
        heading: t("account:emailConfirmation.toast.title"),
        subheading: t("account:emailConfirmation.toast.content"),
        className: "EmailConfirmationValid",
      };

      if (logged) {
        navigate(dashboardRoute, { replace: true });
        dispatchToast({ type: "add", ...successToast });
      } else {
        dispatchToast({ type: "add", ...successToast });
        navigate(routes.Account.Login, { replace: true });
      }
    };

    const handleInvalid = () =>
      navigate(routes.Account.Login, { replace: true });

    switch (keyStatus) {
      case "valid":
        handleValid();
        break;
      case "invalid":
        handleInvalid();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (!loadingLogged) {
      handleKeyStatus();
    }
  }, [keyStatus, loadingLogged]);

  if (keyStatus === "expired")
    return (
      <Main>
        <Header>
          <Heading>
            <Trans
              t={t}
              i18nKey="account:emailConfirmation.heading"
              components={{
                emphasis: <span />,
              }}
            />
          </Heading>
          <SubHeading>
            <span>
              <Trans
                t={t}
                i18nKey="account:emailConfirmation.subheading"
                components={{
                  anchor: <Link to={`mailto:${routes.EmailSupport}`} />,
                }}
              />
            </span>
          </SubHeading>
        </Header>
      </Main>
    );

  return <></>;
}
